export default {
    CREATE_RESERVATION_REQUEST: 'RESERVATION_NEW_CREATE_RESERVATION_REQUEST',
    CREATE_RESERVATION_SUCCESS: 'RESERVATION_NEW_CREATE_RESERVATION_SUCCESS',
    COURSE_SCENARIOS_REQUEST: 'RESERVATION_NEW_COURSE_SCENARIOS_REQUEST',
    COURSE_SCENARIOS_SUCCESS: 'RESERVATION_NEW_COURSE_SCENARIOS_SUCCESS',
    GET_COURSE_REQUEST: 'RESERVATION_NEW_GET_COURSE_REQUEST',
    GET_COURSE_SUCCESS: 'RESERVATION_NEW_GET_COURSE_SUCCESS',
    SCENARIOS_REQUEST: 'RESERVATION_NEW_SCENARIOS_REQUEST',
    SCENARIOS_SUCCESS: 'RESERVATION_NEW_SCENARIOS_SUCCESS',
    SEARCH_INVENTORY_ITEMS_REQUEST: 'RESERVATION_NEW_SEARCH_INVENTORY_ITEMS_REQUEST',
    SEARCH_INVENTORY_ITEMS_SUCCESS: 'RESERVATION_NEW_SEARCH_INVENTORY_ITEMS_SUCCESS',
    DISPOSE: 'RESERVATION_NEW_DISPOSE_STORE',
};
